import AccrualsPageFilter from './AccrualsPageFilter';

export default AccrualsPageFilter;
